import {useRoomsPreheatCanary} from 'components/Offer/hooks/useRoomsPreheatCanary'
import {useTrackSsrRoomsPreheat} from 'components/Offer/hooks/useTrackSsrRoomsPreheat'

/**
 * Renders nothing. Lives under the Select team context so the canary event is attributed to it.
 */
export const RoomsPreheatTracking = () => {
  useTrackSsrRoomsPreheat()
  useRoomsPreheatCanary()
  return null
}
